import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

// material-ui
import { Box, Button, Card, Grid, Typography } from '@mui/material';

import { getPlaces } from 'services/placeServices';

import TableComponent from 'components/TopCourtComponents/Table/TableComponent';
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import CourtFilter from './courtFilter';
import { getUrlCourtCode } from 'helper/Court';
import { useDebounce } from 'use-debounce';

const initFilter = {
  name: '',
  load: true,
  merchant: false
}

function Courts({

}) {
  const [isLoading, setLoading] = useState(true)
  const navigate = useNavigate()
  const [rows, setRows] = useState([])
  const [filter, setFilter] = useState(initFilter)

  const [debouncedFilter] = useDebounce(filter, 500)

  useEffect(() => {
    (async () => {
      if (debouncedFilter.load == true) {
        setLoading(true)
        loadPlace()
      }
    })()
  }, [debouncedFilter])

  const loadPlace = async () => {
    let { data, error } = await getPlaces({
      queryParams: filter ? filter : ''
    })
    if (error) { console.log(error) }
    if (data) {
      setRows(data)
      setLoading(false)
    }
  }

  const valueCustomator = (row) => {
    return ({
      date: <span className='span-link' onClick={() => {
        navigate(`/${getUrlCourtCode()}/courts/edit/${row._id}`)
        // window.location.href = `/${getUrlCourtCode()}/courts/edit/${row._id}` 
      }}>{row.name}</span>,
      orderId: <TCLabel>{row.address}</TCLabel>,
    })
  }

  const onChangeFilter = (e) => {
    setFilter(prev => ({
      ...prev,
      ...e
    }))
  }

  return (
    <>
      {/* <Button variant="contained" sx={{mb:2}} disableElevation onClick={() => {
        // window.location.href = "/courts/add"
        navigate("/courts/add")
      }}>Add New Places</Button> 
      <CourtFilter filter={filter} onChangeFilter={setFilter} /> */}
      <Grid container spacing={2} className="animated fadeIn">
        <Grid item xs={12} sm={4}>
          <Button variant="contained" disableElevation onClick={() => {
            navigate(`/${getUrlCourtCode()}/courts/add`)
          }}>Add New Venue</Button>
        </Grid>
        <Grid item xs={12} sm={8}>
          <CourtFilter filter={filter} onChangeFilter={onChangeFilter} />
        </Grid>
      </Grid>
      <TableComponent
        columns={[
          { label: "Venue" },
          { label: "Address" },
        ]}
        rows={rows}
        valueCustomator={valueCustomator}
        loading={isLoading}
      />
    </>
  )
}

export default Courts;
